// extracted by mini-css-extract-plugin
export default {"root":"SKXOs","stat":"UUlOA","title":"iPBfb","diamondIcon":"U06X5","desktop":"zhhCe","tablet":"RV5Ws","mobile":"X0EnW","smallMobile":"H2yn6"};